export const MODULE_NAMESPACE = 'shopping-basket';

export enum DATA_MESH_IDS {
  ERROR_MODAL = 'ERROR_MODAL',
  ERROR_MODAL_TRY_AGAIN = 'ERROR_MODAL_TRY_AGAIN',
}

export * from './errors';
export * from './totalPrice';
export * from './priceBreakdown';
export * from './dynamicTemplate';
export * from './urlPaths';
